/**
 * SSOT RU-лейблы membership-ролей (зеркало backend/src/utils/companyMembershipRoleLabel.js).
 * Канон: stuj_owner_transfer_hardening §F16
 */

export const COMPANY_MEMBERSHIP_ROLE_LABELS = Object.freeze({
  owner: 'Владелец',
  admin: 'Администратор',
  director: 'Директор',
  manager: 'Менеджер',
  member: 'Сотрудник',
  employee: 'Сотрудник',
  intern: 'Стажёр',
  super_admin: 'Супер-админ',
  viewer: 'Наблюдатель',
  operator: 'Оператор',
  company_admin: 'Администратор',
  hr_director: 'HR-директор',
  hr_manager: 'HR-менеджер',
  hr_viewer: 'HR-наблюдатель',
  shop_owner: 'Владелец магазина',
  shop_admin: 'Админ магазина',
});

/**
 * @param {string|null|undefined} role
 * @param {{ emptyFallback?: string }} [opts]
 * @returns {string}
 */
export function companyMembershipRoleLabel(role, opts = {}) {
  const emptyFallback = opts.emptyFallback || 'Участник';
  const key = String(role || '').trim().toLowerCase();
  if (!key) return emptyFallback;
  return COMPANY_MEMBERSHIP_ROLE_LABELS[key] || key;
}

export default companyMembershipRoleLabel;
